<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar operador</h5>
          <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>
        <div v-if="isLoading" style="padding: 5ch 0">
          <SpeenComponent
              :isAutomatic="true"
              :ringWidth="14"
              :spinnerSize="15"
              :isverticalAligned="true"
          />
        </div>
        <div class="modal-body" v-else>
          <form @submit.prevent="updateOperator">
            <div class="form-group">
              <label for="edit-code-input">Código:</label>
              <input v-model="form.code" id="edit-code-input" required class="form-control" ref="firstInput"/>
            </div>

            <div class="form-group mt-2">
              <label for="edit-name-input">Nombre:</label>
              <input v-model="form.name" id="edit-name-input" required class="form-control"/>
            </div>

            <div class="form-group mt-2">
              <label for="edit-surname-input">Apellidos:</label>
              <input v-model="form.surname" id="edit-surname-input" required class="form-control"/>
            </div>

            <div class="form-group mt-2">
              <label for="edit-email-input">Correo Electrónico:</label>
              <input type="email" v-model="form.email" id="edit-email-input" required class="form-control"/>
            </div>

            <div class="form-group mt-2">
              <label for="edit-phone-input">Teléfono:</label>
              <input type="number" v-model="form.phone" id="edit-phone-input" required class="form-control"/>
            </div>

            <div class="form-group mt-2">
              <label for="edit-operator-title-select">Puesto:</label>
              <select v-model.number="form.operator_title_id" id="edit-operator-title-select" required class="form-control">
                <option v-for="title in operatorTitles" :value="title.id" :key="title.id">
                  {{ title.descrip }}
                </option>
              </select>
            </div>

            <div class="form-group mt-2">
              <label for="edit-salary-input">Salario Bruto Anual:</label>
              <input type="number" v-model="form.annual_base_salary" id="edit-salary-input" required class="form-control"/>
            </div>

            <div class="form-group mt-2">
              <label for="associated-user-select">Usuario Asociado:</label>
              <select v-model.number="form.user_id" id="associated-user-select" class="form-control">
                <option value="">-- Ninguno --</option>
                <option v-for="user in associatedUsers" :value="user.id" :key="user.id">
                  {{ user.username }}
                </option>
              </select>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-success">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
  name: 'OperatorEditModal',
  components: {
    SpeenComponent
  },
  props: {
    operatorId: { type: Number, required: true }
  },
  data() {
    return {
      operatorTitles: [],
      associatedUsers: [],
      form: {
        id: null,
        code: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        operator_title_id: '',
        annual_base_salary: 0,
        user_id: ''
      },
      isLoading: true
    };
  },
  methods: {
    loadSelectOperatorTitles() {
      axios.get('/api/operator-titles')
        .then(response => {
          this.operatorTitles = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    loadSelectAssociatedUsers() {
      axios.get('/api/user')
        .then(response => {
          this.associatedUsers = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    loadOperator() {
      axios.get(`/api/operator/${this.operatorId}`)
        .then(response => {
          const data = response.data;
          this.form = {
            id: data.id || null,
            code: data.code || '',
            name: data.name || '',
            surname: data.surname || '',
            email: data.email || '',
            phone: data.phone || '',
            operator_title_id: data.operator_title_id ? Number(data.operator_title_id) : (this.operatorTitles.length > 0 ? this.operatorTitles[0].id : ''),
            annual_base_salary: data.annual_base_salary || 0,
            user_id: data.user_id ? Number(data.user_id) : ''
          };
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateOperator() {
      axios.patch(`/api/operator/${this.form.id}`, this.form)
        .then(() => {
          showCustomSuccessSweetAlert('Operador editado correctamente');
          this.$emit('operator-edited');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
  mounted(){
    this.loadSelectOperatorTitles();
    this.loadSelectAssociatedUsers();
    this.loadOperator();
  }
};
</script>
